<template>
    <!-- 背包可售道具 -->
    <div class="pocket" v-if="showSellableItemList">
        <el-dialog customClass="wrap" title="背包可售道具" :visible.sync="sellableItemsVisible" 
        :before-close="sellable_items_dialog_close" v-loading="sellableItemloading" append-to-body
         element-loading-background="rgba(0, 0, 0, 0.1)"
         element-loading-text="加载中" element-loading-spinner="el-icon-loading">
            <div class="itembg">
            <div id="itemtitle">
                可售道具
            </div>
            <div id="itemlist" v-if="sellableItems != null">
                <div id="itemcontrol">
                    <input type="checkbox" id="checkAll" @click="checkAll($event);"/>
                    <label for="checkAll">全选</label>&nbsp;&nbsp;
                    <label>（{{sellableItems.length}}/{{POCKET_VOLUME}}）</label>
                    <a @click="sellItems();">批量卖出</a>
                    <br>
                    <div v-if="consignInfo && consignInfo.consign" id="consignTip">
                        寄售店：卖出即寄售上架，按售价扣 {{consignFeeText}}% 手续费；每日限寄售 {{consignInfo.dailyCap}} 件，单种物品货架上限 {{consignInfo.itemCap}} 件。
                    </div>
                    <hr/>
                </div>
                <div v-for="(item,index) in sellableItems" v-bind:key="index" 
                ref="item" class="itemdiv" :id="item.itemId + '_item'">
                    <input name="items" :id="item.itemId" type="checkbox" :value="item.itemId" v-model="checkData"/>
                    <label :for="item.itemId">
                        <img v-if="item.strength!=null && item.strength>-1" :title="item.itemName + ' 体力：' + item.strength" 
                        :src="ossPath + item.imgSrc">
                        <img v-else-if="item.durability!=null && item.durability>-1" :title="item.itemName + ' 评分：' + item.score + ' 耐久：' + item.durability" 
                        :src="ossPath + item.imgSrc">
                        <img v-else-if="item.score!=null && item.score>-1" :title="item.itemName + ' 评分：' + item.score" 
                        :src="ossPath + item.imgSrc">
                        <img v-else :title="item.itemName" :src="ossPath + item.imgSrc">
                        <div v-if="item.stackCount>1" class="stackCount" v-text="item.stackCount"/>
                    </label>
                    <div class="opts">
                        <span>当前收购价：<br/>{{item.curPurchasePrice}}</span>
                        <a @click="sellItem(item.itemId, index);">卖出</a>
                    </div>
                </div>
            </div>
            <div class="noItems" v-if="null == sellableItems">
                暂无可售道具
            </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {getRequest} from '../../utils/api'
import {postRequest} from '../../utils/api'
import {postJson} from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
  name: 'sellableItemList',
  props:{
    sellableItemsVisible: {
      type: Boolean,
      default: false
    },
    fantasyMapShopBO: Object,
    showSellableItemList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        checkData: [], // 双向绑定checkbox数据数组
        sellableItems: [],
        sellableItemloading: false,
        consignInfo: null // 寄售店参数（shopType=4 时从后端拉取）
    };
  },
  computed: {
    // 手续费百分比：后端给的是 double（如 10.0），去掉多余的小数
    consignFeeText() {
      if (!this.consignInfo) return '';
      const v = Number(this.consignInfo.feePercent);
      return isNaN(v) ? '' : String(Math.round(v * 10) / 10);
    }
  },
  watch: {
      // 监视双向绑定的数据数组
      checkData: {
        handler(){ // 数据数组有变化将触发此函数
            if(this.checkData.length == this.sellableItems.length){
                document.querySelector('#checkAll').checked = true;
            }else {
                document.querySelector('#checkAll').checked = false;
            }
        },
        deep: true // 深度监视
      },
      sellableItemsVisible: {
        handler(newVal) {
          if (newVal === true) {
            this.showSellableItems();
          }
        }
      }
  },
  mounted: function () {
      if (this.sellableItemsVisible) {
          this.showSellableItems();
      }
  },
  methods: {
    sellable_items_dialog_close(){
      this.$emit("sellable_items_dialog_close");
    },
    checkAll(e){ // 点击全选事件
      if(e.target.checked){
          this.sellableItems.forEach((el,i)=>{
              // 数组里没有这一个value才push，防止重复push
              if(this.checkData.indexOf(el.itemId) == '-1'){ 
                  this.checkData.push(el.itemId);
              }
          });
      }else { // 全不选选则清空绑定的数组
          this.checkData = [];
      }
    },
    //背包可售道具
    showSellableItems: function(){
      this.sellableItems = [];
      this.sellableItemloading = true;
      // 无商店信息时直接结束加载态，避免 loading 卡死
      if (!this.fantasyMapShopBO || !this.fantasyMapShopBO.shopId) {
        this.sellableItemloading = false;
        this.sellableItems = null;
        return;
      }
      if (4 == this.fantasyMapShopBO.shopType) {
        // 寄售店：先把手续费 / 上限拉到前端，提示条与确认弹窗都用这里的值
        this.consignInfo = null;
        postRequest('/item/shop/consignInfo', {
            shopId: this.fantasyMapShopBO.shopId
        }).then(resp => {
            if (resp.status == 200 && 200 == resp.data.status) {
                this.consignInfo = resp.data.data;
            }
        });
        postRequest('/item/shop/getCreationItems', {
            shopId: this.fantasyMapShopBO.shopId
        }).then(resp=> {
            this.sellableItemloading = false;
            if (resp.status == 200) {
            //成功
            const respData = resp.data;
            if (200 == respData.status) {
                this.sellableItems = respData.data;
                this.itemCount = this.sellableItems.length;
            } else {
                this.sellableItemloading = false;
                this.sellableItems = null;
            }
            } else {
                //失败
                this.sellableItemloading = false;
                Message.error('用户非法⊙﹏⊙∥!22');
            }
        }, resp=> {
            this.sellableItemloading = false;
            Message.error('用户非法⊙﹏⊙∥!11');
        });

      } else {
        postRequest('/item/shop/getSellableItems', {
            shopId: this.fantasyMapShopBO.shopId
        }).then(resp=> {
            this.sellableItemloading = false;
            if (resp.status == 200) {
                this.checkData = [];
            //成功
            const respData = resp.data;
            if (200 == respData.status) {
                this.sellableItems = respData.data;
                this.itemCount = this.sellableItems.length;
            } else {
                this.sellableItemloading = false;
                this.sellableItems = null;
                //Message.error(data.returnMessage);
            }
            //alert(JSON.stringify(this.pocketItems))
            } else {
                //失败
                this.sellableItemloading = false;
                Message.error('用户非法⊙﹏⊙∥!22');
            }
        }, resp=> {
            this.sellableItemloading = false;
            Message.error('用户非法⊙﹏⊙∥!11');
        });
      }
      
    },
    //卖出道具
    sellItem: function(itemId, index){
        let _this = this;
        const consign = this.consignInfo && this.consignInfo.consign;
        const tipMsg = consign
            ? ('您确定要寄售这个道具吗？寄售会按售价扣除 ' + this.consignFeeText + '% 手续费，每日最多寄售 '
                + this.consignInfo.dailyCap + ' 件，且货架有库存上限。')
            : '您确定要卖掉这个道具吗?';
        this.$confirm(tipMsg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function () {
            _this.sellableItemloading = true;
            postRequest('/item/shop/sellItem', {
                itemId: itemId,
                shopId: _this.fantasyMapShopBO.shopId
            }).then(resp=> {
                if (resp.status == 200) {
                    //成功
                    const respData = resp.data;
                    if (200 == respData.status) {
                        _this.showSellableItems();
                        _this.$store.dispatch('user/fetchUserDetail');
                    } else {
                        _this.sellableItemloading = false;
                        Message.error(respData.message);
                    }
                } else {
                    //失败
                    _this.sellableItemloading = false;
                    Message.error('用户非法⊙﹏⊙∥!');
                }
            }, resp=> {
                _this.sellableItemloading = false;
                Message.error('用户非法⊙﹏⊙∥!');
            });
        }, function () {
            //取消
        })
    },
    //批量卖出道具
    sellItems: function(){
        let _this = this;
        console.log(_this.checkData)
        const consign = this.consignInfo && this.consignInfo.consign;
        const tipMsg = consign
            ? ('您确定要寄售这些道具吗？寄售会按售价扣除 ' + this.consignFeeText + '% 手续费，每日最多寄售 '
                + this.consignInfo.dailyCap + ' 件，且货架有库存上限。')
            : '您确定要卖掉这些道具吗?';
        this.$confirm(tipMsg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function () {
            _this.sellableItemloading = true;
            postJson('/item/shop/sellItems', {
                shopId: _this.fantasyMapShopBO.shopId,
                itemIds: _this.checkData
            }).then(resp=> {
                if (resp.status == 200) {
                    //成功
                    const respData = resp.data;
                    if (200 == respData.status) {
                        _this.showSellableItems();
                        _this.$store.dispatch('user/fetchUserDetail');
                    } else {
                        if (respData.message == '我的货物已经满了，暂时不需要了') {
                            Message.error(respData.message);
                            _this.showSellableItems();
                            _this.$store.dispatch('user/fetchUserDetail');
                        } else {
                            _this.sellableItemloading = false;
                            Message.error(respData.message);
                        }
                    }
                } else {
                    //失败
                    _this.sellableItemloading = false;
                    Message.error(resp.message);
                }
            }, resp=> {
                _this.sellableItemloading = false;
                Message.error(resp.message);
            });
        }, function () {
            //取消
        })
    },
  },
  beforeDestroy: function() {
  }
}
</script>

<style scoped>
/* 注意：el-dialog 使用 append-to-body，弹窗DOM不在组件根(.pocket)内，
   后代选择器 .pocket xxx 会失效，因此样式一律不带 .pocket 祖先前缀（scoped data-v 保证唯一） */
a {
    cursor: pointer;
    color: blue;
}
.itembg {
    width:100%;
    height: 400px;
}
#itemtitle {
    padding:3px 5px;
    background-color:#72b653;
    font-size:16px;
    font-weight:bold;
    color:#fff;
    letter-spacing:5px; 
    text-align:center;
}
#itemlist {
    padding:5px;
    text-align:center;
    height: 100%;
    overflow-y: auto;
}
#itemcontrol {
    margin:5px;
    line-height: 40px;
    text-align: left;
}
#itemcontrol input,label,select {
    vertical-align:middle;
}
#consignTip {
    margin: 4px 0 6px;
    padding: 4px 6px;
    background: #fff7e0;
    border: 1px solid #f0c36d;
    color: #8a6d3b;
    font-size: 12px;
    line-height: 1.5;
    text-align: left;
}
.itemdiv {
    height:80px;
    width:70px;
    float:left;
    position:relative;
    margin:5px;
}
.itemdiv input {
    position:absolute;
    top:0;
    left:0;
}
.itemdiv img {
    height:40px;
}
.itemdiv .stackCount {
  position: absolute;
  bottom: 20px;
  font-size: 0.7em;
  width: 100%;
  /* background-color: rgba(233, 141, 66, 0.4); */
}
.opts {
    position:absolute;
    display: none;
    background-color: #aaa;
    z-index: 10;
    width: 90px;
    border:1px solid #f00;
}
.opts a {
    display: block;
    padding: 5px;
    margin: auto;
    text-decoration: none;
}
.opts a:hover {
    text-decoration: underline;
    background-color: #666;
    color: #fff;
}
.itemdiv:hover .opts {
    display:block;
    position:absolute;
    top:30px;
    left:50px;
}
/* 商店中无道具时，提示语显示的样式 */
.noItems {
	padding:3px 5px;
	font-size:16px;
	font-weight:bold;
	letter-spacing:5px;
	text-align:center;
    height: 100px;
    line-height: 100px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .itembg {
    height: auto;
    max-height: 60vh;
  }
  .itemdiv {
    width: 60px;
    height: auto;
    margin: 3px;
    padding-bottom: 42px;
  }
  .itemdiv img {
    height: 32px;
  }
  #itemcontrol {
    font-size: 13px;
    line-height: 30px;
  }
  #itemcontrol input[type="checkbox"] {
    width: 16px;
    height: 16px;
  }
  .opts {
    display: block;
    position: relative;
    top: auto;
    left: auto;
    width: 60px;
    font-size: 11px;
    border: none;
    background: transparent;
    text-align: center;
    margin-top: 2px;
  }
  .opts span {
    display: block;
    font-size: 10px;
    color: #666;
    line-height: 1.3;
  }
  .opts a {
    display: inline-block;
    padding: 3px 6px;
    font-size: 12px;
    background: #72b653;
    color: #fff !important;
    border-radius: 3px;
    margin-top: 2px;
  }
  .opts a:hover {
    background: #5ea044;
  }
  .itemdiv:hover .opts {
    display: block;
    position: relative;
    top: auto;
    left: auto;
  }
}
</style>